"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "../../../client-utils/styled/index.js";
import shouldForwardProp from "../../../client-utils/styled/shouldForwardProp.util.js";
import templateStore from "../../../client-store/template.store.js";
// import hooks
import { useRef } from "react";
import useEventListener from "../../../hooks/useEventListener/index.js";
import { coreComponentName } from "./AppBar.consts.js";
import { DOUBLE, CHILIUPLE, SESQUIPLE, QUADRUPLE } from "../../../constants/numbers.consts.js";
import { NAVIGATION_RAIL_DRAWERWIDTH } from "../../../constants/navigationRail.consts.js";
import AppBar from "../../../components/atoms/AppBar/index.js";
import ToolbarAtom from "../../../components/atoms/Toolbar/index.js";
import DrawerAtom from "../../../components/atoms/Drawer/index.js";
import AppSwitcherIconButtonAtom from "../../../components/atoms/AppBarAppSwitcherIconButton/index.js";
import Chip from "../../../components/atoms/Chip/index.js";
// TODO: move to theme
const Z_INDEX = 3000;
export const Root = styled(AppBar, {
    name: coreComponentName,
    slot: "Root",
})();
export const Toolbar = styled(ToolbarAtom, {
    name: coreComponentName,
    slot: "ToolBar",
})(({ theme }) => ({
    padding: "0px!important",
    position: "relative",
    marginLeft: "0",
    paddingLeft: `calc(${NAVIGATION_RAIL_DRAWERWIDTH}px + (4 * var(--mui-spacing)))!important`,
    zIndex: theme.zIndex.appBar + CHILIUPLE,
}));
export const AppSwitcherIconButton = styled(AppSwitcherIconButtonAtom, {
    name: coreComponentName,
    slot: "AppSwitcherIconButton",
    shouldForwardProp: shouldForwardProp("drawerOpen"),
})(({ active, drawerOpen }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    transition: `background-color 0.2, z-index 0.2s ${drawerOpen ? "step-start" : "step-end"}`,
    zIndex: active ? Z_INDEX : 0,
}));
const RootDrawer = (props) => {
    const ref = useRef(null);
    const _updateSizeHandler = () => {
        const domRect = ref.current?.getBoundingClientRect();
        if (domRect?.height) {
            templateStore.setDrawerHeight(domRect.height);
        }
    };
    useEventListener({
        eventName: "resize",
        payload: _updateSizeHandler,
        options: { runOnInit: true, disabled: !props.open },
    });
    return _jsx(DrawerAtom, { ref: ref, ...props });
};
export const Drawer = styled(RootDrawer, {
    name: coreComponentName,
    slot: "Drawer",
})(({ theme }) => ({
    zIndex: theme.zIndex.appBar + CHILIUPLE,
}));
export const DomainChip = styled(Chip, {
    name: coreComponentName,
    slot: "DomainChip",
    shouldForwardProp: shouldForwardProp("domain"),
})(({ domain, theme }) => ({
    borderRadius: theme.spacing(DOUBLE),
    backgroundColor: theme.vars.palette.domain[domain],
    "& .MuiChip-label": {
        color: theme.vars.palette.common.white,
        padding: theme.spacing(SESQUIPLE, QUADRUPLE),
        fontSize: "14px",
    },
}));
